import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class TempBrandGenericService extends CrudService {
  constructor(public override http: HttpClient) {
    super('temp-brand-generic', http);
  }
}
